import React, { Component } from 'react'
import { HLJ_MERCHANT_WORK_PLATFORM } from '@constant'
import { WithCommon } from '../Common'
import { observer } from 'mobx-react'
import { Button } from 'hljd'
import { getJti, getMerchantInfo, logoutAction } from '@util'
import Store from './store'
import style from './style.module.less'

@observer
class Header extends Component {
  constructor(props) {
    super(props)

    this.store = new Store()
  }

  componentDidMount() {
    this.store.getShopInfo()
  }

  render() {
    const { shopInfo } = this.store
    const { city, name } = getMerchantInfo()

    return (
      <div className={style.content}>
        <div className={style.info}>
          <div className={style.name}>
            {name} {city && <span>({city})</span>}
          </div>

          <div className={style.line} />
        </div>

        <div className={style.propertyAndLogout}>
          <div className={style.propertyList}>
            <div className={style.title}>经营品类：</div>
            {(shopInfo.property_name || []).map((name, index) => (
              <div key={index} className={style.property}>
                {name}
              </div>
            ))}
          </div>

          <div>
            <Button
              type="primary"
              target="_blank"
              href={HLJ_MERCHANT_WORK_PLATFORM + getJti()}
            >
              返回工作台
            </Button>
            &nbsp;&nbsp;
            <Button type="primary" onClick={() => logoutAction()} style={{}}>
              退出登录
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

export default WithCommon(Header)
